import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocusignService {

  constructor(private http: HttpClient) {}

  getRedirectBaseUrl(baseUrl: string): string {
    switch (baseUrl) {
      case 'https://dev-api.unibuild.ai/':
        //return 'http://localhost:4200/';
        return 'https://dev.unibuild.ai/';
      case 'https://test-api.unibuild.ai/':
        return 'https://test.unibuild.ai/';
      case 'https://demo-api.unibuild.ai/':
        return 'https://demo.unibuild.ai/';
      case 'https://api.unibuild.ai/':
        return 'https://www.unibuild.ai/';
      default:
        return 'http://localhost:4200/';
    }
  }

  requestDocumentToSign(baseUrl: string, userData: any): Observable<any> {
    const documentApiUrl = `${baseUrl}auth-service/docu-sign`
    return this.http.post<any>(documentApiUrl, userData);
  }

  requestDocumentToView(baseUrl : string, envelopeId : string) {
    const documentViewApiUrl = `${baseUrl}auth-service/docu-sign/get-document/${envelopeId}`;
    return this.http.get(documentViewApiUrl, { responseType: 'blob' });
  }
}
